"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FormsStore_1 = require("./../../../data/FormsStore");
var CountryAutoComplete_1 = require("./../CountryAutoComplete");
var StateAutoComplete_1 = require("./../StateAutoComplete");
var TextField_1 = require("./../TextField");
var validators = {
    default: function (value) { return Boolean(value); },
};
var Field = (function (_super) {
    __extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFieldChange = function (_a) {
            var value = _a.value, name = _a.name, isValid = _a.isValid;
            FormsStore_1.default.setFieldData(name, { value: value, name: name, isValid: isValid }, _this.props.formName);
        };
        _this.getFieldValue = function (name) {
            var formData = _this.props.formData;
            return formData[name] || { isValid: false, touched: false, value: '' };
        };
        _this.isValid = function (value) { return validators.default(value); };
        return _this;
    }
    Field.prototype.renderFieldByType = function () {
        var data = this.props.data;
        var metadataProps = {
            name: data.name,
            required: data.required,
            errorMessage: data.errorMessage,
            label: data.label,
        };
        switch (data.type) {
            case 'countryCode': {
                return (React.createElement(CountryAutoComplete_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
            case 'state': {
                return (React.createElement(StateAutoComplete_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', countryCode: this.getFieldValue('countryCode').value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
            default: {
                return (React.createElement(TextField_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
        }
    };
    Field.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-field" }, this.renderFieldByType()));
    };
    return Field;
}(React.Component));
exports.default = Field;
//# sourceMappingURL=Field.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/Field/Field.js
// module id = 193
// module chunks = 0 1